import React from 'react';
import { QueryParams, Route } from 'mobx-router';
import Landing from '../components/Landing';
import { RootStore } from '../mobx/RootStore';
import { NotFound } from '../components/NotFound';

const routes = {
	home: new Route<RootStore, QueryParams>({
		path: '/',
		component: <Landing title="wibBTC Wrapper" subtitle="Wrap and Unwrap your ibBTC" />
	}),
	notFound: new Route<RootStore, QueryParams>({
		path: '/not-found',
		component: <NotFound />
	})
};

export default routes;
